import * as types from "./mutation-types";
// import { getRouteList } from "@/api/api.js";
import { filterRouter, fileInfo } from "@/utils/router.js";
import { auth_list } from '@/utils/mock_auth.js';

export const reset = function ({ commit }) {
  commit(types.SET_SAVE_sideBarList, null);
  commit(types.SET_SAVE_sideBarListEN, null);
  commit(types.SET_SAVE_userInfo, {});
};

export const routeList = async function ({ commit }) {
  // const regEN = await getRouteList("en_us");

  // const routersEN = regEN;
  const routersEN = auth_list
  fileInfo(routersEN);

  const newRouterEN = filterRouter(routersEN);

  commit(types.SET_SAVE_sideBarList, newRouterEN);

  commit(types.SET_SAVE_sideBarListEN, newRouterEN);

  return;
};
